// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1d7_Q","productName":"Table_productName__3R3At"};